import React from 'react';
import { Navigate } from 'react-router-dom';
import type { AuthStatus } from './useAuth';

type ProtectedRouteProps = {
  children: React.ReactNode;
  redirectPath?: string;
  status: AuthStatus;
};

export default function ProtectedRoute({
  children,
  redirectPath = '/login',
  status,
}: ProtectedRouteProps) {
  if (status === 'loading') {
    return <div className="p-6 text-center text-sm text-gray-700">Loading authentication...</div>;
  }

  if (status !== 'authenticated') {
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
}
